import {
    getRoleModuleList,
    PermissionOptions,
    userRoleDelete,
    userRoleDetail, UserRoleDetail_AllModule,
    userRoleList,
    getCompanyRoleList,
    userRoleModify
} from "@/api/role";
import {getToken} from "@/utils/auth";


const state = {
    userRoleList: [],
    roleModuleList: [],
    companyRoleList:[],
};
const mutations = {
    SET_ROLE_MODULE_LIST: (state, list) => {
        state.roleModuleList = list;
    },

    SET_ROLE_LIST: (state, list) => {
        state.userRoleList = list;
    },
    SET_FEN_LEI: (state, {first, second}) => {
        state.cate1List = first;
        state.cate2List = second;
    },
    SET_COMPANY_ROLE_LIST: (state, list) => {
        console.log('set cr list',list)
        state.companyRoleList = list;
    },

}

const actions = {
    async getRoleModuleList({commit}) {
        const {data} = await getRoleModuleList({userId: getToken()});
        commit('SET_ROLE_MODULE_LIST', data.map(item => ({
            value: item.moduleId,
            label: item.moduleName,
            permissionsCheckArray: [...PermissionOptions],
            isIndeterminate: false,
            checkAll:true,
        })));
    },

    async UserRoleDetail_AllModule({commit},roleId) {
        const {data} = await UserRoleDetail_AllModule({roleId});
        console.warn('UserRoleDetail_AllModule',data);
       const list =  data.map(item => {
            const {canAdd, canDelete, canExport, canModify, canQuery,selected} = item;
            const permissionsCheckArray = [];
            if (canAdd) {
                permissionsCheckArray.push('添加');
            }
            if (canDelete) {
                permissionsCheckArray.push('删除');
            }
            if (canExport) {
                permissionsCheckArray.push('导出');
            }
            if (canModify) {
                permissionsCheckArray.push('修改');
            }
            if (canQuery) {
                permissionsCheckArray.push('查询');
            }
            const checkAll = permissionsCheckArray.length === PermissionOptions.length;
            return  {
                selected: !!selected,
                value: item.moduleId,
                label: item.moduleName,
                permissionsCheckArray,
                isIndeterminate: false,
                checkAll,
            };

        })
        commit('SET_ROLE_MODULE_LIST', list);
    },


    async userRoleList({commit, rootState}, {key = ''} = {}) {
        commit('SET_ROLE_LIST', (await userRoleList({userId: getToken(), key})).data);
    },

    async companyRoleList({commit, rootState}, {key = ''} = {}) {
        commit('SET_COMPANY_ROLE_LIST', (await getCompanyRoleList({userId: getToken()})).data);
    },

    async userRoleDelete({commit}, {roleId}) {
        return userRoleDelete({userId: getToken(), roleId});
    },

    async userRoleDetail({commit}, {roleId}) {
        const {data} = await userRoleDetail({roleId});
        commit('SET_FEN_LEI', data);
    },
    async userRoleModify({commit, state, rootState}, {roleId, roleName, remark, rightArray}) {
        // console.log('user:',rootState.user);
        return userRoleModify({
            userId: getToken(),
            companyId: rootState.user.companyId,
            roleId,
            roleName,
            remark,
            rightArray
        });
    }

};


export default {
    namespaced: true,
    state,
    mutations,
    actions
}
